import { useQuery } from '@tanstack/react-query';
import { datasetApi, getDatasetRequestConfig } from '../api';

export const OPERATIONS_QUERY = [
  '@MDH',
  'getOperationsApiV2OperationGet',
] as const;

export const useOperations = ({
  datasetName,
  enabled,
  limit,
}: {
  datasetName?: string | undefined;
  enabled?: boolean | undefined;
  limit?: number;
}) => {
  return useQuery({
    queryKey: [...OPERATIONS_QUERY, datasetName],
    refetchInterval: 3000,
    keepPreviousData: true,
    enabled,
    queryFn: () =>
      datasetApi.getOperationsApiV2OperationGet(
        { dataset_name: datasetName, limit },
        getDatasetRequestConfig()
      ),
    select: res => res.data.operations,
  });
};
